import { statesOfIndia } from 'utils/StatesOfIndia';
import { StatutoryContributionsFormData } from './types';

export const portalStatus = {
  registered: 'Registered Employee',
  notRegistered: 'Not Registered',
  exit: 'Exit Employee',
} as const;

export const initialStatutoryContributionsData: StatutoryContributionsFormData = {
  pan: '',
  aadharNumber: '',
  isTdsEnabled: false,
  isPfEnabled: false,
  isAadhaarLinkedToUan: false,
  includeEmployerContributionInCtc: false,
  contributeToEps: false,
  pfWagesCalculationType: ['default'],
  pfStatus: [],
  pfUan: '',
  isEsicEnabled: false,
  esicStatus: [],
  esicIpNumber: '',
  isPtEnabled: false,
  ptState: [],
  isLwfEnabled: false,
  lwfLocation: [],
  isNpsEnabled: false,
  npsPranNumber: '',
};

export const statesOfIndiaCodeMap = statesOfIndia.reduce((acc, state) => {
  acc[state.code] = state.name;
  return acc;
}, {} as Record<number, string>);

//query keys
export const GET_STATUTORY_CONTRIBUTIONS_DATA = 'GET_STATUTORY_CONTRIBUTIONS_DATA';
